<style scoped>
#detail {
  /* position: absolute; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  /* padding-bottom: 128px;
  overflow-y: auto; */
}

#button-container {
  /* position: absolute; */
  bottom: 64px;
  left: 0;
  right: 0;
  height: 64px;
  padding: 0px 10px 8px 10px;
  box-shadow: 0px 0px 10px 11px white;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: space-evenly;
  background-color: #ffffffe0;
}

.root {
  height: 100%;
  position: relative;
}

#button-container a {
  flex: 1;
  height: 100%;
  line-height: 56px;
  margin-left: 2.5px;
  margin-right: 2.5px;
}

.input-field,
.input-field label {
  padding-left: 35px;
}

ul.order-items li {
  padding-top: 24px;
}

ul.order-items li:not(:last-child) {
  border-bottom: 1px solid #efefef;
}

@media only screen and (max-width: 600px) {
  #button-container {
    bottom: 0px;
  }

  #detail {
    padding-bottom: 64px;
  }
}
</style>

<template lang="pug">
.root
  #detail
    .container
      .vspace.large.col.s12
      .row
        .col.s12
          p.title.large.no-margin-bottom {{ job.deliveryJobReferenceNumber }}
          p.subtitle.small.no-margin-top.green-text Cash
          .vspace.medium
          p.subtitle.micro Ordered on
            span.black-text {{ $utils.formatter.formatLongDateTime(job.order.createdAt) }}
      .vspace.large.col.s12
      .divider.col.s12
      .vspace.large.col.s12
      .row
        .col.s12
          p.subtitle.small Supplied by
          p.title.small {{ job.productVariant.product.supplier.name }}
      .row
        .col.s12
          p.subtitle.small Ordered by
          p.title.small {{ receiver }}
      .row
        .col.s12
          p.subtitle.small Deliver to
          p.title.small {{ job.address }}
      .row
        .col.s12.m8
          label
            input(
              type='checkbox',
              @change='onItemChange(job, $event.target.checked)',
              :disabled='!canSelect(job)'
            )
            span.title.medium.text-uppercase.black-text {{ job.quantity }} X {{ job.productVariant.product.name }}
              span.subtitle.micro(:class='getStatusClass(job.status)') &nbsp;&nbsp;{{ job.status }}
              p.subtitle.micro ({{ job.productVariant.variantCode }})
              p.subtitle.micro Deliver {{ getDeliverySchedule(job.deliverySchedule) }}
        .col.s12.m4
          p.right-align {{ $utils.formatter.formatAmount(job.price) }}
  #button-container(v-if='selectedItems.length')
    a.btn.red.darken-2.waves-effect(v-if='showDeclineOption', @click='decline') Decline
    a.btn.red.darken-2.waves-effect(v-if='showCancelOption', @click='cancel') Cancel
    a.btn.waves-effect.indigo(
      v-if='showAcceptOption',
      @click='accept',
      :class='{ disabled: !canAccept }'
    ) Accept
    a.btn.waves-effect.blue-grey.darken-1(
      v-if='showInTransitOption',
      @click='requestDelivery'
    ) Request Delivery
    a.btn.waves-effect.indigo(v-if='showInTransitOption', @click='inTransit') In-transit
    a.btn.waves-effect.green(
      v-if='showDeliveredOption',
      @click='delivered',
      :class='{ disabled: !canDeliver }'
    ) Delivered
</template>
<script>
/* eslint-disable no-undef */
import axios from 'axios'
import AppConfirmModalContent from './app-confirm-modal-content'

export default {
  props: ['job'],
  data() {
    return {
      STATUS_NEW: 'new',
      STATUS_DECLINED: 'declined',
      STATUS_CANCELLED: 'cancelled',
      STATUS_PROCESSING: 'processing',
      STATUS_INTRANSIT: 'in-transit',
      STATUS_DELIVERED: 'delivered',
      selectedItems: [],
    }
  },
  watch: {
    '$route.params.referenceNumber'() {
      this.resetSelection()
    },
  },
  computed: {
    showDeclineOption() {
      return this.selectedItems.every((item) => item.status === this.STATUS_NEW)
    },
    showCancelOption() {
      return this.selectedItems.every((item) =>
        [this.STATUS_INTRANSIT, this.STATUS_PROCESSING].includes(item.status)
      )
    },
    showAcceptOption() {
      return this.showDeclineOption
    },
    canAccept() {
      return this.selectedItems.every(this.hasAvailableInventory)
    },
    showInTransitOption() {
      return this.selectedItems.every(
        (item) => item.status === this.STATUS_PROCESSING
      )
    },
    showDeliveredOption() {
      return this.selectedItems.every(
        (item) => item.status === this.STATUS_INTRANSIT
      )
    },
    canDeliver() {
      return this.selectedItems.every(
        (item) =>
          item.status === this.STATUS_INTRANSIT && item.deliveredBy === 'inomph'
      )
    },
    receiver() {
      return `${this.job.order.account.firstName} ${this.job.order.account.lastName} (${this.job.order.account.email} | ${this.job.contactNumber})`
    },
  },
  methods: {
    setOrderItemShop(item, shopId) {
      this.selectedItems.some((selectedItem, index) => {
        if (item.id === selectedItem.id) {
          selectedItem.productVariant.inventories.some((inventory) => {
            if (inventory.shop.id === shopId) {
              selectedItem.fromInventory = inventory
              this.selectedItems.splice(index, 1, selectedItem)
              return true
            }
          })
          return true
        }
      })
    },
    canSelect(item) {
      return ![
        this.STATUS_DECLINED,
        this.STATUS_DELIVERED,
        this.STATUS_CANCELLED,
      ].includes(item.status)
    },
    resetSelection() {
      this.selectedItems = []
      document.querySelectorAll('input[type=checkbox]').forEach((checkbox) => {
        checkbox.checked = false
      })
    },
    getDeliverySchedule(value) {
      if (value === 'same_day') {
        return 'By Today'
      } else if (value.startsWith('range')) {
        return (
          'By ' + value.split(':')[1].replace(';', ' to ') + ' business days'
        )
      } else if (value.startsWith('scheduled')) {
        return 'On ' + value.split(':')[1]
      }
    },
    onItemChange(item, isSelected) {
      if (isSelected) {
        this.selectedItems.push(item)

        if (item.status === this.STATUS_NEW) {
          this.$nextTick(() => {
            let select = this.$M.FormSelect.init(
              document.getElementById('select-' + item.id)
            )
            this.setOrderItemShop(item, select.el.value)
          })
        }
      } else {
        this.selectedItems = this.selectedItems.filter(
          (curItem) => curItem.id !== item.id
        )
      }
    },
    getStatusClass(status) {
      return {
        'indigo-text': status === this.STATUS_NEW,
        'green-text': status === this.STATUS_DELIVERED,
        'red-text':
          status === this.STATUS_DECLINED || status === this.STATUS_CANCELLED,
        'blue-text': status === this.STATUS_INTRANSIT,
        'orange-text': status === this.STATUS_PROCESSING,
      }
    },
    updateStatus(status, issue) {
      this.resetSelection()
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return axios.post(
          `${this.$config.API_URL}/suppliers/${this.job.productVariant.product.supplier.id}/orders/${this.job.order.id}/order-item/${this.job.id}/status`,
          {
            status: status,
            issue: issue,
            deliveredBy: 'inomph',
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
      })
    },
    delivered() {
      return this.updateStatus(this.STATUS_DELIVERED).then(() => {
        this.$snackbar.success('Items delivered')
        this.$emit('orderUpdated', this.job)
      })
    },
    cancel() {
      const modalParams = {
        content: AppConfirmModalContent,
        style: { padding: 'medium' },
        bind: {
          action: 'Cancel',
          onConfirm: this.confirmCancel,
          onCancel: this.cancelDecline,
          orderReferenceNumber: this.job.referenceNumber,
        },
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    confirmCancel(reasonForCancel) {
      return this.updateStatus(this.STATUS_CANCELLED, reasonForCancel).then(
        () => {
          this.$store.dispatch('modal/close')
          this.$snackbar.success('Item cancelled')
          this.$emit('orderUpdated', this.job)
        }
      )
    },
    confirmDecline(reasonForDecline) {
      return this.updateStatus(this.STATUS_DECLINED, reasonForDecline).then(
        () => {
          this.$store.dispatch('modal/close')
          this.$snackbar.success('Item declined')
          this.$emit('orderUpdated', this.job)
        }
      )
    },
    cancelDecline() {
      this.$store.dispatch('modal/close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-job-details.vue